import React, { useEffect, useRef, useState } from "react";
import { Button, TextField } from "@mui/material";
import axiosInstance from "../../server/axios";
import { databaseNoport } from "../../server/server";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Autocomplete from '@mui/material/Autocomplete';

import Downexcel from "./downexcel";

const Dataupdate = () => {
  const today = new Date();
  const [showData, setShowData] = useState('material');
  const [materialList, setMaterialList] = useState([]);
  const [filterList, setfilterList] = useState([]);
  const [exceltitle, setExceltitle] = useState([]);
  const [excelContents, setExcelContents] = useState([]);
  const [checkDate, setCheckDate] = useState(`${today.getFullYear()-3}-01-01`);
  const [totaldata, setTotaldata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [dateCount, setDateCount] = useState(0);
  const [filterData, setFilterData] = useState([]);
  const [materialSearch, setMaterialSearch] = useState([]);
  const [materialnamelist,setMaterialnamelist] = useState([])

  const changeShow = (datatype) => {
    if(datatype === 'material'){setShowData('filter');}
    if(datatype === 'filter'){setShowData('material');}
  }
  const viewPre = (_path,filename) => {
    const path = _path.substring(1);
    const text = `${databaseNoport}`.replace('happyfront/index.html#','');
    const realpath = text+'happyserver'+path;
    return window.open(`${realpath}`,'targetWindow',
      `toolbar=no,
       location=no,
       top=200,
       left=300,
       status=no,
       menubar=no,
       scrollbars=yes,
       resizable=yes,
       width=800px,
       height=1100px`);
  }
  const downloading = async (path,filename) => {
    const response = await axiosInstance.get(`/material/file?path=${path}&filename=${filename}`,{responseType: 'blob'})
    const file = new Blob([response.data], {type: 'application/pdf'});
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}`);
    document.body.appendChild(link);
    link.click();
  }
  const changeDate = (event) => {
    const checkvalue = event.target.value;
    setCheckDate(checkvalue);
    let count = 0;
    for(let i = 0; i < totalCount; i++){
      if(checkvalue <= totaldata[i].date ){count++;}
    }
    setDateCount(count);
  }
  useEffect(()=>{
    const getMaterial = async () => {
      const materialdata = await axiosInstance.get(`/admin/filelist`);
      const filterLength = materialdata.data.filter.length;
      const dataLength = materialdata.data.list.length;
      const filterInfo = materialdata.data.filter.map((value)=>{return value.info});
      let materialname = '';
      const exceltitle = ['원료명'].concat(filterInfo);
      const totallist = [];
      const namelist = [];
      let partlist = [];
      let dateCount = 0;
      setTotalCount(dataLength);
      for(let i = 0; i < dataLength; i++){
        if(checkDate <= materialdata.data.list[i].date){dateCount++;};
        if(materialname !== materialdata.data.list[i].name){
          if(partlist.length !== 0){totallist.push(partlist)}
          partlist = [];
          materialname = materialdata.data.list[i].name
          namelist.push(materialdata.data.list[i].name.replace(/:apo:/g,"'"));
          partlist.push(materialdata.data.list[i].name.replace(/:apo:/g,"'"));
          for(let j = 0; j < filterLength; j++){
            if(filterInfo[j] === materialdata.data.list[i].filter){
              partlist.push({
                filename:materialdata.data.list[i].filename.replace(/:apo:/g,"'"),
                path:materialdata.data.list[i].path.replace(/:apo:/g,"'"),
                date:materialdata.data.list[i].date
              })
            }else{
              partlist.push(false);
            }
          }
          continue;
        }
        if(materialname === materialdata.data.list[i].name){
          for(let j = 0; j < filterLength; j++){
            if(filterInfo[j] === materialdata.data.list[i].filter){
              partlist[j+1] = {
                filename:materialdata.data.list[i].filename.replace(/:apo:/g,"'"),
                path:materialdata.data.list[i].path.replace(/:apo:/g,"'"),
                date:materialdata.data.list[i].date
              };
            }
          }
          continue;
        }
      }
      setMaterialnamelist([...namelist]);
      setTotaldata([...materialdata.data.list]);
      setDateCount(dateCount);
      setfilterList([...materialdata.data.filter]);
      setExceltitle([...exceltitle]);

       const excelcontents =  totallist.map((arr)=>{return arr.map((value,i)=>{
          if(i === 0){return value;}
          if(value === false){return '-';}
          return value.date;
        })
      })
      setExcelContents([...excelcontents])

      setMaterialList([...totallist]);

      //filter
      const filterList = await axiosInstance.get(`/admin/getfilterlist`);
      const datalist = [];
      const dataindex = [];
      for(let i = 0; i < filterList.data.length; i++){
        const groupname = filterList.data[i].materialgroup;
        const index = dataindex.indexOf(groupname);
        if(index === -1){
          dataindex.push(groupname);
          datalist.push({
            group_name:filterList.data[i].materialgroup,
            group_id:filterList.data[i].group_id,
            group_info:filterList.data[i].info,
            filterArr:[filterList.data[i].filter],
            group_sort:filterList.data[i].sortnumber,
          })
          continue;
        }
        if(index !== -1){
          datalist[index].filterArr.push(filterList.data[i].filter);
          continue;
        }
      }
      setList([...dataindex])
      setFilterData([...datalist]);
    };
    getMaterial();

  },[])
  const [inputValue, setInputValue] = useState("");
  const materiaTable = () => {
    return (
      <>
        <div style={{fontSize:'2rem',float:'left'}}>Seach :  
          <Autocomplete
          freeSolo 
          options={materialnamelist}
          filterOptions={(opts, { inputValue }) => {
            //const words = inputValue.trim().split(/\s+/); // 공백 기준으로 단어 분리
            //return words.length >= 3 ? opts : []; // 단어가 2개 이상일 때만 옵션 반환
            const words = inputValue; // 공백을 기준으로 단어 분리
            if (words.length < 3) return []; // 두 단어 이상 입력해야 옵션을 보여줌
            const optionsarray = opts.filter((values,i)=>{
              if(values.toLowerCase().indexOf(words.toLowerCase()) !== -1){
                return values;
              }
            });
            return optionsarray;
          }}
          inputValue={inputValue}
          onInputChange={(event, newValue) => {
            setInputValue(newValue);
            if (newValue.length < 3) return []; // 두 단어 이상 입력해야 옵션을 보여줌
            const resultarr = materialList.filter((values,i)=>{
              if(values[0].toLowerCase().indexOf(newValue.toLowerCase()) !== -1){return values;}
            });
            setMaterialSearch([...resultarr]);
          }}
          sx={{ width: 500 ,display:'inline-block'}}
          renderInput={(params) => <TextField {...params} label="검색창, 3글자이상 입력해야 결과 출력" />}
          />
          <div style={{display:'inline-block'}}>{Downexcel(exceltitle,excelContents,'material_data')}</div>
        </div>
        <table className="company_main">
        <thead>
          <tr>
            <th><div className="underline">No</div></th>
            <th className="toptable">
              품명
              <div><input type="date" value={checkDate} onChange={changeDate}></input></div>
              <div>Total:{totalCount}</div>
              <div>check:{dateCount}</div>
            </th>
            {
              filterList.map((value)=>
                <th><div className="underline">{value.info}</div></th>
              )
            }
          </tr>
        </thead>
        <tbody>
          {
            materialSearch.map((value,num)=>
              <tr>
                <td>{num+1}</td>
                {
                  value.map((val,i) =>
                    i === 0 ?
                    <td className="companyname"><div className="rightline2">{val}</div></td>
                    :
                    val === false ?
                    <td></td>
                    :
                    <td>
                      { val.date > checkDate ?
                        <Button  variant="contained" color="success" size="big" onClick={()=>viewPre(val.path,val.filename)}>
                        {val.date}
                        </Button>
                        :
                        <Button  variant="contained" color="error" size="big" onClick={()=>viewPre(val.path,val.filename)}>
                        {val.date}
                        </Button>
                      }
                    </td>
                  )
                }
              </tr>
            )
          }
        </tbody>
      </table>
      </>

    )
  }
  const getFilterTable = async() => {
    const filterList = await axiosInstance.get(`/admin/getfilterlist`);
    const datalist = [];
    const dataindex = [];
    for(let i = 0; i < filterList.data.length; i++){
      const groupname = filterList.data[i].materialgroup;
      const index = dataindex.indexOf(groupname);
      if(index === -1){
        dataindex.push(groupname);
        datalist.push({
          group_name:filterList.data[i].materialgroup,
          group_id:filterList.data[i].group_id,
          group_info:filterList.data[i].info,
          filterArr:[filterList.data[i].filter],
          group_sort:filterList.data[i].sortnumber,
        })
        continue;
      }
      if(index !== -1){
        datalist[index].filterArr.push(filterList.data[i].filter);
        continue;
      }
    }
    setList([...dataindex])
    setFilterData([...datalist]);
  }
  const addGroup = async (_groupname) => {
    const addgroup = await axiosInstance.post(`/admin/addgroup`,{groupname:_groupname});
    getFilterTable();
  }
  const sortFilter = async (sortlist) => {
    const sort = await axiosInstance.post('/admin/sortfilter',{sort:sortlist});
    getFilterTable();
  }
  const editGroup = async (_groupname,_id) => {
    const updated = await axiosInstance.post('/admin/editgroup',{groupname:_groupname,group_id:_id});
    getFilterTable();
  }
  const editInfo = async (_groupinfo,_id) => {
    const updated = await axiosInstance.post('/admin/editgroupinfo',{groupinfo:_groupinfo,group_id:_id});
    getFilterTable();
  }
  const addFilter = async (_filtername,_id) => {
    const addfilter = await axiosInstance.post('/admin/addfilter',{filter:_filtername,group_id:_id});
    getFilterTable();
  }

  

  //dragging
	const dragItem = useRef(null); // Specify the type for dragItem
	const dragOverItem = useRef(null); // Specify the type for dragOverItem

	const [list, setList] = useState([]);

	const dragStart = (e,position) => {
		dragItem.current = position;
	};

	const dragEnter = (e, position) => {
		dragOverItem.current = position;
	};

	const drop = (e) => {
		const copyListItems = [...list];
		const dragItemContent = copyListItems[dragItem.current];
		copyListItems.splice(dragItem.current, 1);
		copyListItems.splice(dragOverItem.current, 0, dragItemContent);
		dragItem.current = null;
		dragOverItem.current = null;
    sortFilter(copyListItems);

    setList(copyListItems);
  };
/*
	return (
		<>
			{list.map((item, index) => (
					<div
						key={index}
						draggable
						onDragStart={(e) => dragStart(e, index)}
						onDragEnter={(e) => dragEnter(e, index)}
						onDragEnd={drop}
						onDragOver={(e) => e.preventDefault()}
					>
						{item}
					</div>
				))}
		</>
	);
*/
  //modal infomation
  const [open, setOpen] = useState(false);
  const [modalColor, setModalColor] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [editType, setEditType] = useState('');
  const [changedData, setChangeData] = useState('');
  const [changed_ID, setChange_ID] = useState(null);
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
  };
  const handleOpen = (_title,nextstep,color,_id) =>{
    setModalTitle(`${_title}`);
    setModalColor(`${color}`);
    setChange_ID(_id);
    if(nextstep === 'addgroup'){setEditType('addgroup');}
    if(nextstep === 'editgroup'){setEditType('editgroup');}
    if(nextstep === 'editgroupinfo'){setEditType('editgroupinfo');}
    if(nextstep === 'addfilter'){setEditType('addfilter');}
    setOpen(true);
  };
  const sendChangeData = () => {
    if(editType === 'addgroup'){addGroup(changedData)}
    if(editType === 'editgroup'){editGroup(changedData,changed_ID);}
    if(editType === 'editgroupinfo'){editInfo(changedData,changed_ID);}
    if(editType === 'addfilter'){addFilter(changedData,changed_ID);}
    setChangeData('');
    handleClose();
  }
  const handleClose = () => setOpen(false);
  const changeGradeData = (event) => {
    setChangeData(event.target.value);
  }

  const showFilterTable = () => {
    return (
      <>
      <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
      <Box sx={style}>
        <div className="modalbox_grade">
          <div style={{height:'50px',textAlign:'center',fontSize:'2rem',fontWeight:'500'}}>{modalTitle}</div>
          <TextField id="outlined-basic" label="변경 사항 입력" variant="outlined" color="secondary" onChange={changeGradeData}/>
          <Button                
          variant="contained" 
          color={modalColor} 
          size="big" 
          onClick={()=>sendChangeData()}
          >Submit</Button>
        </div>
      </Box>
      </Modal>
      <table className="company_main">
        <thead>
          <tr>
          <th>No</th>
          <th>
            <Button variant="contained" color="secondary" onClick={()=>handleOpen('필터 그룹 추가','addgroup','secondary',0)}>
              필터그룹 추가
            </Button>
          </th>
          <th>그룹수정</th>
          <th>그룹 정보</th>
          <th>그룹정보수정</th>
          <th>filter list</th>
          <th>Add filter</th>
          </tr>
        </thead>
        <tbody>
        {filterData.map((object,i)=>
        <tr 
          key={i}
          draggable
          onDragStart={(e) => dragStart(e, i)}
          onDragEnter={(e) => dragEnter(e, i)}
          onDragEnd={drop}
          onDragOver={(e) => e.preventDefault()}
        >
          <td>{i+1}</td>
          <td className="rightline">{object.group_name}</td>
          <td >
            <Button variant="contained" color="primary" onClick={()=>handleOpen(`${object.group_name} 그룹 명 수정`,'editgroup','primary',object.group_id)}>
            {'그룹명 수정'}
            </Button>
          </td>
          <td className="filterinfo">{object.group_info}</td>
          <td>
          <Button variant="contained" color="success" onClick={()=>handleOpen(`${object.group_name} 정보 수정`,'editgroupinfo','success',object.group_id)}>
          {'그룹설명 수정'}
          </Button>
          </td>
          <td className="rightline">{object.filterArr.map((filter)=>
            <div style={{display:'inline',border:'2px solid red',borderRadius:'20px',marginRight:'10px',marginLeft:'3px',padding:'5px'}}>{filter}</div>
          )}</td>
          <td>
          <Button variant="contained" color="error" onClick={()=>handleOpen(`${object.group_name} 필터 추가`,'addfilter','error',object.group_id)}>
          {'필터추가'}
          </Button>
          </td>
        </tr>          
        )}
        </tbody>
      </table>
      </>
    )
  }
/*
      <div className="filterOutline">
        <div>
        <div className="filterMainth">
          <div className="number">No</div>
          <div className="group_name">
            <Button variant="contained" color="secondary" onClick={()=>handleOpen('필터 그룹 추가','addgroup','secondary')}>
              필터그룹 추가
            </Button>
          </div>
          <div className="group_name_edit">그룹수정</div>
          <div className="group_info">그룹 정보</div>
          <div className="group_info_edit">그룹정보수정</div>
          <div className="group_filter">filter list</div>
          <div className="add_filter">Add filter</div>
        </div>
        {filterData.map((obejct,i)=>
        <div className="filterMain"
          key={i}
          draggable
          onDragStart={(e) => dragStart(e, i)}
          onDragEnter={(e) => dragEnter(e, i)}
          onDragEnd={drop}
          onDragOver={(e) => e.preventDefault()}
        >
          <div className="number">{i+1}</div>
          <div className="group_name">{obejct.group_name}</div>
          <div className="group_name_edit">
            <Button variant="contained" color="primary" onClick={()=>handleOpen(`${obejct.group_name} 그룹 명 수정`,'editgroup','primary')}>
            {'그룹명 수정'}
            </Button>
          </div>
          <div className="group_info">{obejct.group_info}</div>
          <div className="group_info_edit">
          <Button variant="contained" color="success" onClick={()=>handleOpen(`${obejct.group_name} 정보 수정`,'addfilter','success')}>
            {'그룹설명 수정'}
            </Button>
          </div>
          <div className="group_filter">{obejct.filterArr.map((filter)=>
            <div style={{display:'inline',border:'2px solid red',borderRadius:'20px',marginRight:'10px',marginLeft:'3px',padding:'5px'}}>{filter}</div>
          )}</div>
          <div className="add_filter">
            <Button variant="contained" color="error" onClick={()=>handleOpen(`${obejct.group_name} 필터 추가`,'addfilter','error')}>
            {'필터추가'}
            </Button>
          </div>
        </div>
        )}
        </div>
      </div>
*/

  return (
    <><Button variant="contained" color="secondary" size="big" onClick={()=>changeShow(showData)}>
      {showData === 'material' ? <>{'show FilterTable'}</>:<>{'show MaterialList'}</>}
      </Button>    
      <br></br>
      {showData === 'material' ? materiaTable() : showFilterTable()}
    </>
  )










/*
  const [yearList,setYearList] = useState(['2009']);
  const [BuyData,setBuyData] = useState([]);
  const GetBuyData = (event) => {
    setBuyData(event.target.value);
  }
  const sendData = (event) => {
    event.preventDefault();
    const settdata = document.getElementById("selldata").innerHTML;

    //console.log(settdata);

    const changeDataToArray = (_exceldata) => {
      const toArrayData = _exceldata.replace("</table>","").split("</tr>");
      toArrayData.pop();

      const datacell = toArrayData.map((val)=>{
        const SplitTdArr = val.split("</td>");
        SplitTdArr.pop();

        const CellArr = SplitTdArr.map((val)=>{
          let Celldata = val.trim();
          let checkingTag = true;
          while(checkingTag === true){
            const startIndex = Celldata.indexOf('<');
            const endIndex = Celldata.indexOf('>');    
            if(startIndex === -1 && endIndex === -1){checkingTag = false;}
            Celldata = Celldata.substr(endIndex+1);
          }
          let checkingNbsp = true;
          while(checkingNbsp === true){
            const Index = Celldata.indexOf('&nbsp;');
            if(Index === -1){checkingNbsp = false;}
            Celldata = Celldata.replace('&nbsp;','');
          }
          return Celldata;
        })
        return CellArr;
      })

      console.log(datacell);
      return toArrayData;
    }
    const exceldata = changeDataToArray(settdata);
    //console.log(exceldata)
  }
  return (
        <div>
          <Button  variant="contained" color="success" size="big" onClick={sendData}>Get Data</Button>
          <br></br>
          <div 
          contentEditable="true"
          suppressContentEditableWarning={true}
          id="selldata"
          className="contentedit"
          onChange={GetBuyData}
          >
          </div>
        </div>
    );
*/
}
export default Dataupdate;